import React, { useEffect, useState, useRef } from 'react';
import { ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import useValidator from '../../../../hooks/generic/Form/useValidator';
import { safeMutate } from '../../../../utils/GeneralUtils';
import { getDataFromProps, getUId, propagateData } from '../utils';
import SrLabel from './SrLabel';
import './ChrText.css';
import ChrAsterisk from '../../PageUI/Basic/ChrAsterisk';

// TODO : Introduce PropTypes

// Structure:
// data: {
//   uId: ,
//   name: required[fallback uId],
//   label: ,
//   labelClass: ,
//   value: ,
//   defaultValue: ,
//   disabled: ,
//   readOnly: ,
//   className:
// },
// maxLength,
// helpText,
// helpTextClasses,
// extraProps: {
//   componentClass: ,
//   rows: ,
//   cols:
// }

const ChrText = (props) => {
  const formData = getDataFromProps(props);
  const myUId = getUId(props);
  const { inputRef, error, validationHandler } = useValidator({
    inputRef: props.inputRef,
    inputValidations: props.inputValidations,
    validateOnRender: props.validateOnRender
  });
  const errorClass = error ? "border-danger" : "";
  const classNames = [props.formControlClass, errorClass].join(" ");
  const isTouched = useRef(false);

  useEffect(() => {
    if(props.forceValidate) {
      validationHandler();
      isTouched.current = true;
    }
  }, [props.forceValidate, props.validateOnChange]);

  useEffect(() => {
    if (!props.skipBlurOnValidate)
      propagateData('onBlur', myUId, error, props);
    // The propagation is done here to send the error if any when the filter is rendered at once. This is to indicate error present in the saved data. The error occuring while filling the input is handled in onBlurHandler below.
  }, [error]);

  const onChangeHandler = (event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = event.target.value;
    });
    props.validateOnChange && (props.isInlineInput || isTouched.current) && validationHandler();
    propagateData(event, myUId, newFormData, props);
  };

  const onKeyDownHandler = (event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = event.target.value;
    });
    propagateData(event, myUId, newFormData, props);
  };

  const onClickHandler = (event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = event.target.value;
    });
    propagateData(event, myUId, newFormData, props);
  };

  const onFocusHandler = (event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = event.target.value;
    });
    propagateData(event, myUId, newFormData, props);
  };

  const onBlurHandler = (event) => {
    if(!props.skipValidationOnBlur)
      validationHandler();
    isTouched.current = true;
    propagateData(event, myUId, error, props);
  };

  const formControlRef = ref => {
    if (inputRef) inputRef.current = ref;
  };

  return (
    <React.Fragment>
      <FormGroup className={ props.formGroupClass }>
        { props.srLabel && <SrLabel>{ props.srLabel }</SrLabel> }
        { formData.label && <ControlLabel className={formData.labelClass} >
          {formData.label}
          {formData.required && <ChrAsterisk />}
        </ControlLabel> }
        <div className={`input-group ${props.inputGroupClass}`}>
          {
            props.iconWrapperClass && props.iconClass && <div className={props.iconWrapperClass}>
            <i className={props.iconClass} aria-hidden="true"></i>
            </div>
          }
          {
            props.inputGroupPrefix && <div className = {`input-group-addon ${props.inputGroupPrefix.className}`}>
              { props.inputGroupPrefix.content }
            </div>
          }
          <FormControl
            className={classNames}
            inputRef={formControlRef}
            type={props.type || 'text'}
            name={formData.name}
            value={formData.value}
            defaultValue={formData.defaultValue}
            onChange={onChangeHandler}
            onKeyDown={onKeyDownHandler}
            onClick={onClickHandler}
            onFocus={onFocusHandler}
            onBlur={onBlurHandler}
            placeholder={formData.placeholder}
            readOnly={formData.readOnly || false}
            disabled={formData.disabled || false}
            aria-label={props.ariaLabel}
            maxLength={props.maxLength}
            {...props.extraProps}
            {...props.formControlOptions}
          />
          {
            props.inputGroupSuffix && <div className = {`input-group-addon ${props.inputGroupSuffix.className}`}>
              { props.inputGroupSuffix.content }
            </div>
          }
        </div>
        { props.helpText && <HelpBlock className={props.helpTextClasses}> { props.helpText }</HelpBlock> }
        { !props.hideErrorMessage && error && <HelpBlock className="block">{ error }</HelpBlock> }
      </FormGroup>
    </React.Fragment>
  );
};

export default ChrText;